import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 0.5rem;
`;

export const Text = styled.span`
  font-size: 1.4em;
  font-weight: 600;
  margin: 1rem 0;
`;

export const GoodsContainer = styled.div`
  padding: 0.4rem 0;
  box-shadow:
    rgba(0, 0, 0, 0.05) 0px 0px 0px 1px,
    rgb(209, 213, 219) 0px 0px 0px 1px inset;
`;
